import { lazy } from "react";
import { Navigate, RouteObject } from "react-router";
import App from "../app";
import { Resource } from "@exibra/shared";
import { Routes } from "./routes";
import AuthPage from "@/pages/auth/auth-page";
import { TenantSelection } from "@/pages/tenant/tenant-selection";
import { CreateTenant } from "@/pages/tenant/create-tenant";
import { AppSetupRedirector } from "@/app-setup-redirector";
import { TenantManagement } from "@/pages/tenant-management/tenant-management";
import { ScreenPairing } from "@/pages/screen-pairing/screen-pairing";
import { templateRouterConfig } from "@/pages/templates/templates-router.config";
import { usersRouterConfig } from "@/pages/users/users-router.config";

const Screens = lazy(() => import("../pages/screens/screens"));
const ScreenDetails = lazy(() => import("../pages/screens/pages/screen-details/screen-details"));

export const routerConfig: RouteObject[] = [
    {
        path: "/",
        element: <App />,
        children: [
            {
                path: "",
                element: <AppSetupRedirector />,
            },
            {
                path: Routes.TenantSelection,
                element: <TenantSelection />,
            },
            {
                path: Routes.CreateTenant,
                element: <CreateTenant />,
            },
            {
                path: `${Routes.Screens}/pair/:uuid`,
                element: <ScreenPairing />,
            },
            {
                path: `${Routes.Tenant}/:id`,
                element: <TenantManagement />,
                children: [
                    {
                        index: true,
                        element: <Navigate to={Resource.Screen} replace />,
                    },
                    {
                        path: Resource.Screen,
                        children: [
                            {
                                index: true,
                                element: <Screens />,
                            },
                            {
                                path: ":screenId",
                                element: <ScreenDetails />,
                            },
                        ],
                    },
                    ...templateRouterConfig,
                    ...usersRouterConfig,
                ],
            },
        ],
    },
    {
        path: Routes.Auth,
        element: <AuthPage />,
    },
];
